export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '23ffbdcb-58ed-4e92-925f-a9c28cbdf7f6';
export const MODAL_CLOSE_SEC = 2.5;
